import http from '../http'
import url from './index-url'
const { post } = http

export default {
  getInsQuota(data) {
    return post(url.getInsQuota, data)
  }
}